import { create } from 'zustand';

import type { AuthUser } from '@/types';

interface AuthState {
  // State
  isAuthenticated: boolean;
  user: AuthUser | null;
  accessToken: string | null;
  isLoading: boolean;

  // Actions
  setAuth: (user: AuthUser, accessToken: string) => void;
  setAccessToken: (accessToken: string) => void;
  clearAuth: () => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  // Initial state
  isAuthenticated: false,
  user: null,
  accessToken: null,
  isLoading: true,

  // Actions
  setAuth: (user: AuthUser, accessToken: string) =>
    set({
      isAuthenticated: true,
      user,
      accessToken,
      isLoading: false,
    }),

  setAccessToken: (accessToken: string) =>
    set((state) => ({
      ...state,
      accessToken,
    })),

  clearAuth: () =>
    set({
      isAuthenticated: false,
      user: null,
      accessToken: null,
      isLoading: false,
    }),

  setLoading: (loading: boolean) =>
    set((state) => ({
      ...state,
      isLoading: loading,
    })),
}));